import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogPostTitleInterface } from 'common/types/entities/BlogPostTitleInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'

export function createBlogPostTitle(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): BlogPostTitleInterface {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.BlogPostTitle,
      parentId,
      masterBlockId,
    ),
    fontSize: 27,
    color: 'rgba(0, 0, 0, 1)',
    mobileFontSize: 20,
    alignSelf: 'center',
  }
}
